import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import SkeletonLoaderWrapper from "../../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { getRouteUrl } from "../../../../helpers/routing/getRouteUrl";
import { ROUTE_PAGE_HOME } from "../../../../routers/routes";
import IssueForm from '../../components/form/form'
import useIssue from '../../hooks/useIssue'

const Edit = (props) => {
	let { IssueId } = useParams()
	if (!IssueId) {
		IssueId = props.IssueId
	}
	const { onSuccess, onClose } = props
	const history = useHistory()
	const { loading, issue, staticData, issueDataManager } = useIssue({ IssueId })
	const onSuccessAction = onSuccess ? onSuccess : () => history.push(getRouteUrl(ROUTE_PAGE_HOME))
	return (
		<SkeletonLoaderWrapper loading={loading}>
			{Object.keys(issue).length > 0 && (
				<IssueForm
					issueDataManager={issueDataManager}
					onClose={onClose}
					onSuccess={onSuccessAction}
					IssueId={IssueId}
					issue={issue}
					staticData={staticData}
					isEdit={true}
					Copy={Boolean(props.Copy)}
					fromDashboard={props.fromDashboard}
				/>
			)}
		</SkeletonLoaderWrapper>
	)
}

export default Edit